<template>
  <div>
    <h1>APOYO FOTOGRÁFICO</h1>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex'
import SelectLocal from './../../own/select-local.vue'

export default {
  name: '',
  props: ['project_id', 'assignment_id'],  
  computed: {
    ...mapGetters(['projectId', 'assignmentId', 'project', 'assignment', 'selects'])
  },  
  data() {
    return {
			message: '',
			typeMessage: ''
    }
  },
  components: {
    'select-local': SelectLocal,
  },  
  methods: {
    ...mapMutations(['changeProjectId', 'changeAssignmentId', 'changeProject', 'changeAssignment', 'changeSelects']),
    defaultAxios(){
			var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
			axios.defaults.headers['x-csrf-token'] = token
			axios.defaults.headers.common['Accept'] = 'application/json';
			axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },
    getInformationWork() {
      console.log("3***")
			axios.get(`/information_work.json?project_id=${this.project_id}&assignment_id=${this.assignment_id}`).then(res=>{
				if(res.status == 200){
          this.changeProject(res.data.project)
          this.changeAssignment(res.data.assignment)
				}
			})
    },
    save(){
      this.defaultAxios()
			axios.put(`/update_information_personal`, { project: this.project }).then(res=>{
				if(res.status == 200){
          this.getInformationWork()
          this.showMessage('Proceso actualizado', 'alert-success')
				}else{
          this.showMessage('El registro no se pudo actualizar', 'alert-danger')
        }
			}, (err) => {
        this.showMessage('El registro no se pudo actualizar', 'alert-danger')
      })
    },
		showMessage(message, typeMessage){
			this.message = message
			this.typeMessage = typeMessage
			setTimeout(() => this.message = '', 3000)
		},        
  },
  created () {

  },
  watch: {
    data(newValue, oldValue) {
      
    }
  },
  filters: {
    fnName: function(value) {
      return value;
    }
  }
}
</script>

<style scoped>

</style>